<template lang="html">
  <div id="footer">
		<div class="container med-container">
			<div class="row">
				<div class="col-md-5 col-lg-6 col-logo">
					<router-link to="/">
						<img src="public/images/logo.png">
					</router-link>
				</div>

				<div class="col-md-7 col-lg-6 col-copy">
					<p>
						© 2025 Marquez Express. Todos los derechos reservados.
					</p>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
}
</script>
